function htmlspecialchars(str) {
  var map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;" // ' -> &apos; for XML only
  };
  return str.replace(/[&<>"']/g, function (m) { return map[m]; });
}

export function lineNumbers(code, lang, highlight) {
  let lines = code.split(/\n/);
  for (let l = 0; l < lines.length; l++) {
    let indent = lines[l].split(/\S/)[0].length; // counting whitespaces
    lines[l] = `<span class="line-number">${l +
      1}</span><span class="hljs-ln-line${l == 0 ? ' first-hljs-line' : ''}" style="padding-left: ${indent}__indentpx__px; text-indent: -${indent}__indentpx__px;">${
      highlight ? lines[l] : htmlspecialchars(lines[l])
      }</span>`;
  }
  code = lines.join("\n");
  code = highlight ? `<span class='line-border'></span>` + code : `<pre><code class="code-block language-${lang}"><span class='line-border'></span>${code}</code></pre>`;

  return code;
}